import { LitEntity, html, css } from '../../utility/lit-entity';
import { BinIssueStateMixin } from './bin-issue-state-mixin';

class BinIssueStateLevelQuestion extends BinIssueStateMixin(LitEntity) {
  static get styles() {
    return [...super.styles, css`
      bin-profile {
        height: 25vh;
        max-height: 250px;
        margin: 1em 0;
      }
    `];
  }

  render() {
    return html`
      <h2>Do the levels of this bin look correct?</h2>
      <bin-profile .href="${this.href}"></bin-profile>
      ${this.renderYesNo()}
    `;
  }
}

window.customElements.define('bin-issue-state-level-question', BinIssueStateLevelQuestion);
